import * as React from 'react'

import { Button } from '../primitives/Button'
import type { ButtonProps } from '../primitives/Button'

interface ActionIconButtonProps extends Omit<ButtonProps, 'children'> {
  icon: React.ReactNode
  label?: string
}

export function ActionIconButton({
  icon,
  label,
  ...props
}: ActionIconButtonProps) {
  return (
    <Button {...props} title={props.title || label}>
      {icon}
    </Button>
  )
}
